import { useState } from "react";
import DetailsDialog, { DetailsProps } from "../DetailsDialog";
import TextInputField from "../ui/TextInputField";

const CustomerDetails = (props: DetailsProps) => {
  const [name, setName] = useState<string>();

  const initializeFields = (data: any) => {
    setName(data.name);
  };

  const collectData = () => ({ name });

  const renderFields = () => (
    <>
      <h2>Wprowadź dane klienta</h2>
      <TextInputField
        label='Nazwa'
        autoFocus
        initialValue={name}
        onValueChange={setName} />
    </>
  );

  return (
    <DetailsDialog
      { ...props }
      resource='customers'
      renderFields={renderFields}
      initializeFields={initializeFields}
      collectData={collectData}
    />
  );
};
export default CustomerDetails;